import { render, staticRenderFns } from "./Testimony.vue?vue&type=template&id=6244f542&scoped=true"
import script from "./Testimony.vue?vue&type=script&lang=js"
export * from "./Testimony.vue?vue&type=script&lang=js"
import style0 from "./testimony.css?vue&type=style&index=0&id=6244f542&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6244f542",
  null
  
)

export default component.exports